module.exports = __webpack_public_path__ + "static/media/Dolni_hory.b886636b.md";